export default {
    "settings.title": "Paramètres",
    "settings.description": "Gérez votre compte, vos préférences et votre abonnement.",
    "settings.nav.profile": "Profil",
    "settings.nav.appearance": "Apparence",
    "settings.nav.notifications": "Notifications",
    "settings.nav.security": "Sécurité",
    "settings.nav.billing": "Facturation",
    "settings.nav.logout": "Déconnexion",

    "settings.profile.title": "Informations Personnelles",
    "settings.profile.subtitle": "Mettez à jour vos informations de base.",
    "settings.profile.name": "Nom complet",
    "settings.profile.name_placeholder": "Votre nom",
    "settings.profile.email": "Adresse email",
    "settings.profile.email_help": "L'email ne peut pas être modifié pour des raisons de sécurité.",
    "settings.profile.save": "Enregistrer les modifications",
    "settings.profile.success": "Profil mis à jour avec succès !",

    "settings.appearance.title": "Personnalisation",
    "settings.appearance.subtitle": "Adaptez l'interface à vos préférences.",
    "settings.appearance.mode": "Mode actuel :",
    "settings.appearance.light": "Clair",
    "settings.appearance.dark": "Sombre",

    "settings.security.title": "Mot de passe",
    "settings.security.subtitle": "Changez votre mot de passe pour plus de sécurité.",
    "settings.security.current_password": "Mot de passe actuel",
    "settings.security.new_password": "Nouveau mot de passe",
    "settings.security.confirm_password": "Confirmer le nouveau mot de passe",
    "settings.security.update": "Mettre à jour le mot de passe",
    "settings.security.success": "Mot de passe mis à jour avec succès !",
    "settings.security.error_match": "Les mots de passe ne correspondent pas.",
    "settings.security.error_length": "Le mot de passe doit contenir au moins 6 caractères.",
    "settings.security.error_current": "Le mot de passe actuel est incorrect.",

    "settings.billing.title": "Abonnement & Facturation",
    "settings.billing.subtitle": "Gérez vos paiements et votre formule actuelle.",
    "settings.billing.current_plan": "Formule actuelle",
    "settings.billing.free_plan": "Version Gratuite",
    "settings.billing.status_active": "Actif",
    "settings.billing.status_canceled": "Annulé",
    "settings.billing.view_offers": "Voir les offres",
    "settings.billing.renewal": "Renouvellement le",
    "settings.billing.ends": "Prend fin le",
    "settings.billing.price_yearly": "{{price}}$ / an",
    "settings.billing.price_monthly": "{{price}}$ / mois",
    "settings.billing.change_plan": "Changer de formule",
    "settings.billing.portal_title": "Gestion Stripe",
    "settings.billing.portal_description": "Gérez vos factures, votre mode de paiement et l'annulation via notre portail sécurisé.",
    "settings.billing.portal_cta": "Accéder au portail client",
    "settings.billing.portal_error": "Erreur lors de l'accès au portail",
    "settings.billing.portal_error_help": "Veuillez contacter le support si le problème persiste.",

    "settings.danger.title": "Zone de danger",
    "settings.danger.description": "La suppression de votre compte est irréversible. Toutes vos données, votre progression et vos badges seront définitivement effacés.",
    "settings.danger.cta": "Supprimer mon compte",

    "settings.delete.title": "Supprimer le compte",
    "settings.delete.warning": "Êtes-vous absolument sûr ? Cette action ne peut pas être annulée.",
    "settings.delete.confirm_help": "Veuillez saisir votre email ({{email}}) pour confirmer la suppression.",
    "settings.delete.placeholder": "Confirmez votre email",
    "settings.delete.cancel": "Annuler",
    "settings.delete.confirm": "Supprimer définitivement",
    "settings.delete.deleting": "Suppression...",
    "settings.delete.error_email": "L'email saisi ne correspond pas.",
    "settings.delete.error_generic": "Une erreur est survenue lors de la suppression."
};
